import Config from 'utils/config';
import { compressToUTF16 as lzStringCompress, decompressFromUTF16 as lzStringDecompress } from 'lz-string';

/*
 * Used to store any items by their type
 * All storage is persistant: Kept for lieftime of session, cleared only when user logs out
 * Can be debugged in Developer Tools -> Application -> Local Storage
 */

function hash(key) {
  if (Config.debug) {
    return key;
  }
  var hash = 0;
  if (key.length === 0) {
    return hash;
  }
  for (let i = 0; i < key.length; i++) {
    hash = ((hash << 5) - hash) + key.charCodeAt(i);
    hash |= 0;
  }
  return hash;
}

function clear() {
  localStorage.clear();
}

function contains(key) {
  return localStorage.getItem(hash(key)) != null;
}

function remove(key) {
  return localStorage.removeItem(hash(key));
}

function getString(key) {
  return localStorage.getItem(hash(key));
}

function setString(key, string) {
  localStorage.setItem(hash(key), string);
}

function getBoolean(key) {
  if (Config.debug) {
    return localStorage.getItem(hash(key)) === 'true';
  }
  else {
    return localStorage.getItem(hash(key)) === 'f29b';
  }
}

function setBoolean(key, bool) {
  if (Config.debug) {
    localStorage.setItem(hash(key), bool ? 'true' : 'false');
  }
  else {
    localStorage.setItem(hash(key), bool ? 'f29b' : 'e71a');
  }
}

function getNumber(key) {
  const number = localStorage.getItem(hash(key));
  if (number === null) {
    return null;
  }
  return parseInt(number);
}

function setNumber(key, number) {
  localStorage.setItem(hash(key), number);
}

function getData(key) {
  const data = localStorage.getItem(hash(key));
  if (data === null) {
    return null;
  }
  return JSON.parse(data);
}

function setData(key, data) {
  localStorage.setItem(hash(key), JSON.stringify(data));
}

function getCompressedData(key) {
  if (Config.debug) {
    return getData(key);
  }
  const data = localStorage.getItem(hash(key));
  if (data === null) {
    return null;
  }
  return JSON.parse(lzStringDecompress(data));
}

function setCompressedData(key, data) {
  if (Config.debug) {
    return setData(key, data);
  }
  localStorage.setItem(hash(key), lzStringCompress(JSON.stringify(data)));
}

const Storage = {
  clear,
  contains,
  remove,
  getString,
  setString,
  getBoolean,
  setBoolean,
  getNumber,
  setNumber,
  getData,
  setData,
  getCompressedData,
  setCompressedData,
}

export default Storage;